<template lang="pug">

    div.ui.two.column.centered.grid          

        div.column.centered.row#error-page

            i.massive.icon(:class='info.icon')
            
            h1.ui.header
                
                .content
                    //- i.small.icon(:class='info.icon')
                    | {{ title }}
                    .sub.header {{ message }}

        div.column.centered.row
            .button.ui.primary.button(type='button' v-on:click='goHome()') Zur Startseite

</template>

<script>
    import { default_route } from '@/utils/role'

    // Maps an HTTP/error status to the information shown on the error page.
    const ERROR_INFO = {
        403: { icon: 'frown open outline', title: 'Zugriff verweigert', message: 'Du hast keine Berechtigung, diese Seite oder Ressource zu sehen.' },
        404: { icon: 'surprise outline', title: 'Seite nicht gefunden', message: 'Die angeforderte Seite wurde nicht gefunden.' },
        500: { icon: 'dizzy outline', title: 'Interner Serverfehler', message: 'Auf dem Server ist ein Fehler aufgetreten. Bitte versuche es später erneut oder kontaktiere den Support.' }
    }

    const DEFAULT_INFO = { icon: 'warning sign', title: 'Es ist ein Fehler aufgetreten', message: 'Es ist ein unerwarteter Fehler aufgetreten. Bitte versuche es erneut.' }

    //noinspection JSUnusedGlobalSymbols
    export default {

        props: {
            statusCode: {
                type: [Number, String],
                default: 404
            }
        },

        computed: {

            code() {
                return Number(this.statusCode) || 404
            },

            info() {
                return ERROR_INFO[this.code] || DEFAULT_INFO
            },

            title() {
                return `${this.code} – ${this.info.title}`
            },

            message() {
                return this.info.message
            }

        },

        methods: {

            goHome() {
                this.$router.push(default_route(this.$auth.activeRoleId))
            }

        }

    }

</script>

<style scoped>

    #error-page {
        margin: 4rem auto 0;
        max-width: 1000px;
    }

    #error-page > .icon {
        color: rgba(0, 0, 0, 0.2);
    }

    #error-page > .header {
        font-size: 4rem;
        color: rgba(0, 0, 0, 0.2);
    }

    #error-page > .content {
        text-shadow: 1px 1px 1px rgba(255, 255, 255, 0.8);
    }

</style>
